<div class="row" *ngIf="widgetType && w && w.timeSeriesList">
    <div class="col-lg-3">
      <div class="form-group">
        <h3>Name</h3>
        <input type="text" placeholder="widget name" max="15" class="form-control" [(ngModel)]="w.name">
      </div>
    </div>
    <div class="col-lg-3">
      <div class="form-group">
        <h3>Valid Period</h3>        
        <app-time-period [(period)]="w.period" [type]="'text'"></app-time-period>
      </div>
    </div>
    <div class="col-lg-3">
      <div class="form-group input-group-sm">
        <h3>Refresh (Seconds)</h3>
        <input min="60" type="text" placeholder="refresh interval" class="form-control" [(ngModel)]="w.refreshInterval"/>
      </div>
    </div>
    <div class="col-lg-3">
      <div class="form-group input-group-sm">
        <label>Widget Size</label>
        <select [(ngModel)]="w.size" class="form-select">
          <option value="1">1</option>
          <option value="2">2</option>
          <option value="3">3</option>
          <option value="4">4</option>
          <option value="5">5</option>
          <option value="6">6</option>
          <option value="12">12</option>
        </select>
      </div>
    </div>
  </div>
  <div class="row" *ngIf="widgetType && w && w.timeSeriesList">
    <div class="col-lg-4">
      <div class="form-group input-group-sm">
        <label>Select Time Series </label>
        <app-uri-select [customerId]="dashboard.customerId" [timeSeriesDetail]="w.timeSeriesList[0]" [enableMediaSearch]="true" [enableTimeSeriesSearch]="false" [enableTagMatch]="true" [siteTypeCode]="dashboard.siteType" [siteUri]="siteUri"></app-uri-select>
        <!--<app-time-series-select [timeSeriesDetail]="w.timeSeriesList[0]" [enableTagMatch]="true"></app-time-series-select>-->
      </div>
      <div class="form-group">
        <app-transform-editor [transforms]="w.timeSeriesList[0].transforms"></app-transform-editor>
      </div>
    </div>

    <!-- Editor or images and ranges -->
    <div class="col-lg-8">
      <table class="table">
        <tr>
          <th>
            <label>Min</label>
          </th>
          <th>
            <label>Max</label>
          </th>
          <th>Image</th>
          <th><a (click)="addImage()"><i class="fa fa-plus"></i></a></th>
        </tr>
        <tr *ngIf="w.images == null || w.images.length == 0">
            <td colspan="3">No Images</td>
        </tr>
        <tr *ngFor="let imgObj of w.images">
          <td>
            <input type="number" size="5" [(ngModel)]="imgObj.min" class="input-group form-control" width=""/>
          </td>
          <td>
            <input type="number" size="5" [(ngModel)]="imgObj.max" class="input-group form-control"/>
          </td>
          <td>
            <input *ngIf="imgObj.image == null" type="file" class="form-control" (change)="uploadImageFile($event.target.files, imgObj)" placeholder="Upload file" accept=".png,.jpg,.jpeg,.gif,.svg"/>
            <button class="btn btn-xs" (click)="clearImg(imgObj)"><i *ngIf="imgObj.image != null" class="fa fa-check"></i></button>
          </td>
          <td>
              <a (click)="removeImage(imgObj)"><i class="fa fa-minus"></i></a>
          </td>
        </tr>
      </table>
    </div>
  </div>

  
